import { AbstractRequestClass, DetailRequestModel } from './abstract-request.class';
import { AvailabilityMappingRequest } from './abstract-request.constants';
import { DataObject } from '../../../../../../models/data-object.models';

export class AvailabilityRequestClass extends AbstractRequestClass {
  public getMultiEndPoints(): DetailRequestModel[] | null {
    return null;
  }
  public getMappingRequest(): DataObject {
    return AvailabilityMappingRequest;
  }
}
